// MakNorte — handoff único do checkout (CPF/CNPJ + convivência Pix/Scala e cartão/nativo).
// Carregado uma vez pelo layout (defer): o drawer do carrinho chega por morph e scripts inline ali não executam.
(function () {
  if (window.__makCheckoutHandoffLigado) return;
  window.__makCheckoutHandoffLigado = true;

  // --- CPF/CNPJ (2026-09-08) ---
  function soDigitos(v) { return (v || '').replace(/\D/g, ''); }
  function cpfValido(d) {
    if (d.length !== 11 || /^(\d)\1+$/.test(d)) return false;
    for (var t = 9; t < 11; t++) {
      var soma = 0;
      for (var i = 0; i < t; i++) soma += parseInt(d.charAt(i), 10) * (t + 1 - i);
      var dv = (soma * 10) % 11; if (dv === 10) dv = 0;
      if (dv !== parseInt(d.charAt(t), 10)) return false;
    }
    return true;
  }
  function cnpjValido(d) {
    if (d.length !== 14 || /^(\d)\1+$/.test(d)) return false;
    var pesos1 = [5,4,3,2,9,8,7,6,5,4,3,2], pesos2 = [6,5,4,3,2,9,8,7,6,5,4,3,2];
    function dv(base, pesos) {
      var soma = 0;
      for (var i = 0; i < pesos.length; i++) soma += parseInt(base.charAt(i), 10) * pesos[i];
      var r = soma % 11; return r < 2 ? 0 : 11 - r;
    }
    return dv(d, pesos1) === parseInt(d.charAt(12), 10) && dv(d, pesos2) === parseInt(d.charAt(13), 10);
  }
  function formatarDoc(d) {
    if (d.length <= 11) return d.replace(/(\d{3})(\d)/, '$1.$2').replace(/(\d{3})(\d)/, '$1.$2').replace(/(\d{3})(\d{1,2})$/, '$1-$2');
    return d.replace(/^(\d{2})(\d)/, '$1.$2').replace(/^(\d{2})\.(\d{3})(\d)/, '$1.$2.$3').replace(/\.(\d{3})(\d)/, '.$1/$2').replace(/(\d{4})(\d)/, '$1-$2');
  }
  // Mensagem específica: o cliente precisa saber se falta dígito ou se o número não confere.
  function mensagemDoc(d) {
    if (!d.length) return 'Informe o CPF ou CNPJ para emitir a nota fiscal.';
    if (d.length < 11) return 'CPF incompleto: faltam ' + (11 - d.length) + (11 - d.length === 1 ? ' dígito.' : ' dígitos.');
    if (d.length === 11) return 'CPF inválido: confira os números digitados.';
    if (d.length < 14) return 'CNPJ incompleto: faltam ' + (14 - d.length) + (14 - d.length === 1 ? ' dígito.' : ' dígitos.');
    return 'CNPJ inválido: confira os números digitados.';
  }
  function campoDoc(origem) {
    var raiz = (origem && origem.closest && origem.closest('.cart__ctas')) ? origem.closest('.cart__ctas').previousElementSibling : null;
    if (raiz && raiz.hasAttribute && raiz.hasAttribute('data-mak-cpf')) return raiz;
    var todos = document.querySelectorAll('[data-mak-cpf]');
    for (var i = 0; i < todos.length; i++) { if (todos[i].offsetParent !== null) return todos[i]; }
    return todos[0] || null;
  }
  function docOk(origem) {
    var raiz = campoDoc(origem); if (!raiz) return { ok: true, valor: '' };
    var input = raiz.querySelector('[data-mak-cpf-input]'), erro = raiz.querySelector('[data-mak-cpf-erro]');
    var d = soDigitos(input.value);
    // 12/10/2026: campo opcional. Vazio segue (o Mercado Pago pede o CPF/CNPJ no pagamento); só trava se digitado errado.
    if (!d.length) { raiz.classList.remove('mak-cpf--erro'); if (erro) erro.hidden = true; return { ok: true, valor: '' }; }
    var ok = cpfValido(d) || cnpjValido(d);
    raiz.classList.toggle('mak-cpf--erro', !ok);
    if (erro) { erro.hidden = ok; if (!ok) erro.textContent = mensagemDoc(d); }
    if (!ok) { input.focus(); input.scrollIntoView({ block: 'center', behavior: 'smooth' }); }
    return { ok: ok, valor: ok ? formatarDoc(d) : '' };
  }
  document.addEventListener('input', function (ev) {
    var input = ev.target instanceof Element ? ev.target.closest('[data-mak-cpf-input]') : null;
    if (!input || ev.isComposing) return;
    var d = soDigitos(input.value).slice(0, 14);
    input.value = formatarDoc(d);
    var raiz = input.closest('[data-mak-cpf]');
    if (raiz && raiz.classList.contains('mak-cpf--erro') && (cpfValido(d) || cnpjValido(d))) {
      raiz.classList.remove('mak-cpf--erro');
      var erro = raiz.querySelector('[data-mak-cpf-erro]'); if (erro) erro.hidden = true;
    }
  }, true);

  // Rastreio pelo servidor (2026-09-23): leva os códigos do Facebook e o navegador até o pedido,
  // como atributos ocultos (prefixo _), para a compra paga ser ligada ao anúncio na Conversions API.
  // Endereço pelo CEP salvo: o checkout só puxa a rua quando o CEP é digitado lá; por isso
  // o cartão abre o checkout já com rua, cidade e UF (ViaCEP). Falhou/demorou? segue o fluxo normal.
  function urlCheckoutComEndereco() {
    return new Promise(function (resolve) {
      try {
        if (typeof fetch !== 'function' || typeof localStorage === 'undefined') return resolve(null);
        var cep = String(localStorage.getItem('maknorte_cep') || '').replace(/\D/g, '');
        if (cep.length !== 8) return resolve(null);
        var pronto = false;
        var fim = function (v) { if (!pronto) { pronto = true; resolve(v); } };
        setTimeout(function () { fim(null); }, 2500);
        fetch('https://viacep.com.br/ws/' + cep + '/json/').then(function (r) { return r.json(); }).then(function (d) {
          if (!d || d.erro || !d.uf || !d.localidade) return fim(null);
          var campos = { zip: cep.slice(0, 5) + '-' + cep.slice(5), country: 'BR', province: d.uf, city: d.localidade };
          if (d.logradouro) campos.address1 = d.logradouro;
          var qs = Object.keys(campos).map(function (k) {
            return 'checkout[shipping_address][' + k + ']=' + encodeURIComponent(campos[k]);
          }).join('&');
          fim('/checkout?' + qs);
        }, function () { fim(null); });
      } catch (e) { resolve(null); }
    });
  }

  function lerCookie(nome) {
    var m = (document.cookie || '').match(new RegExp('(?:^|; )' + nome + '=([^;]{1,500})'));
    return m ? decodeURIComponent(m[1]) : '';
  }
  function atributosRastreio() {
    var out = {};
    var fbp = lerCookie('_fbp'), fbc = lerCookie('_fbc');
    if (/^fb\.\d\.\d{10,13}\.\d+$/.test(fbp)) out._fbp = fbp;
    if (/^fb\.\d\.\d{10,13}\.[A-Za-z0-9_\-.]+$/.test(fbc)) out._fbc = fbc;
    var ua = (typeof navigator !== 'undefined' && navigator.userAgent) ? String(navigator.userAgent).slice(0, 400) : '';
    if (ua) out._mn_ua = ua;
    return out;
  }

  function gravarDocumento(doc, extras) {
    var attrs = {};
    try {
      var rastreio = typeof document !== 'undefined' && document.cookie !== undefined ? atributosRastreio() : {};
      for (var chaveR in rastreio) { if (Object.prototype.hasOwnProperty.call(rastreio, chaveR)) attrs[chaveR] = rastreio[chaveR]; }
    } catch (e) {}
    if (doc) attrs['CPF/CNPJ'] = doc;
    if (extras) {
      for (var chaveExtra in extras) {
        if (Object.prototype.hasOwnProperty.call(extras, chaveExtra)) attrs[chaveExtra] = String(extras[chaveExtra]);
      }
    }
    var chaves = Object.keys(attrs);
    if (!chaves.length) return { promise: Promise.resolve(), cancel: function () {} };
    var controller = typeof AbortController === 'function' ? new AbortController() : null;
    var request = {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ attributes: attrs })
    };
    if (controller) request.signal = controller.signal;
    var promise = fetch('/cart/update.js', request).then(function (r) {
      if (!r.ok) throw new Error('Não conseguimos confirmar os dados do carrinho. Tente novamente.');
      if (!r.json || typeof r.json !== 'function') throw new Error('Não conseguimos confirmar os dados do carrinho. Tente novamente.');
      return r.json();
    }).then(function (payload) {
      if (!payload || typeof payload !== 'object') throw new Error('Não conseguimos confirmar os dados do carrinho. Tente novamente.');
      var retornados = payload.attributes;
      for (var k = 0; k < chaves.length; k++) {
        var chave = chaves[k], esperado = attrs[chave];
        var confirmado = Array.isArray(retornados)
          ? retornados.some(function (item) { return item && item.key === chave && String(item.value == null ? '' : item.value) === esperado; })
          : !!retornados && typeof retornados === 'object' && String(retornados[chave] == null ? '' : retornados[chave]) === esperado;
        if (!confirmado) throw new Error('Não conseguimos confirmar os dados do carrinho. Tente novamente.');
      }
      return payload;
    });
    return {
      promise: promise,
      cancel: function () { if (controller) controller.abort(); }
    };
  }

  function scalaDoEvento(evento) {
    var caminho = evento && typeof evento.composedPath === 'function' ? evento.composedPath() : [];
    var host = null, botao = null;
    for (var i = 0; i < caminho.length; i++) {
      var node = caminho[i];
      if (node && node.tagName === 'SCALA-CART-BUTTON') host = node;
      if (node && node.id === 'scala-button') botao = node;
    }
    return host && botao ? { host: host, botao: botao } : null;
  }

  // Pix (Scala) e cartão (checkout nativo) convivem: o cliente escolhe. Nada fica oculto quando o Pix está pronto.
  function rotularNativo(nativo, comoCartao) {
    var padrao = nativo.querySelector ? nativo.querySelector('[data-mak-cta-default]') : null;
    var cartao = nativo.querySelector ? nativo.querySelector('[data-mak-cta-card]') : null;
    if (padrao) padrao.hidden = !!comoCartao;
    if (cartao) cartao.hidden = !comoCartao;
    if (comoCartao) nativo.setAttribute('data-mak-card-cta', '1'); else nativo.removeAttribute('data-mak-card-cta');
  }
  function containerDe(nativo) {
    return (nativo.closest && nativo.closest('.cart__ctas')) || nativo.parentElement || document;
  }
  // O botão do app Scala vive num shadow root fechado ao leitor de tela: o host vira um botão de verdade
  // (nome, foco e teclado), e Enter/Espaço acionam o botão interno.
  function tornarScalaAcessivel(host, botao) {
    if (!host || typeof host.setAttribute !== 'function' || typeof host.getAttribute !== 'function') return;
    if (host.getAttribute('data-mak-a11y') === '1') return;
    host.setAttribute('data-mak-a11y', '1');
    host.setAttribute('role', 'button');
    host.setAttribute('tabindex', '0');
    var rotulo = (botao && botao.textContent ? botao.textContent : '').replace(/\s+/g, ' ').trim();
    host.setAttribute('aria-label', rotulo || 'Finalizar compra com Pix');
    if (typeof host.addEventListener !== 'function') return;
    host.addEventListener('keydown', function (evento) {
      if (evento.key !== 'Enter' && evento.key !== ' ') return;
      evento.preventDefault();
      var alvo = host.shadowRoot ? host.shadowRoot.querySelector('#scala-button') : null;
      if (alvo && typeof alvo.click === 'function') alvo.click();
    });
  }
  // --- Reserva do botão Pix (2026-09-23) ---
  // Mostra o botão Pix na hora; o Scala assume quando carregar. Toque antecipado fica guardado e segue sozinho.
  var RESERVA_LIMITE_MS = 12000;
  function naPaginaCarrinho() {
    return typeof location !== 'undefined' && /^\/cart\/?$/.test(location.pathname || '');
  }
  function reservaAtiva(reserva) {
    if (!reserva || !reserva.getAttribute || reserva.getAttribute('data-mak-pix-expirada') === '1') return false;
    // Na gaveta o app Pix não renderiza: a reserva fica e leva o cliente à página do carrinho.
    if (!naPaginaCarrinho()) return true;
    var desde = Number(reserva.getAttribute('data-mak-pix-desde') || 0);
    if (!desde) { desde = Date.now(); reserva.setAttribute('data-mak-pix-desde', String(desde)); }
    if (Date.now() - desde <= RESERVA_LIMITE_MS) return true;
    reserva.setAttribute('data-mak-pix-expirada', '1');
    reserva.hidden = true;
    if (reserva.getAttribute('data-mak-pix-pendente') === '1') {
      reserva.removeAttribute('data-mak-pix-pendente');
      var status = document.querySelector('[data-mak-checkout-status]');
      if (status) {
        status.textContent = 'O Pix não carregou agora. Finalize pelo cartão ou fale com um consultor no WhatsApp.';
        status.hidden = false;
      }
    }
    return false;
  }
  function liberarReserva(reserva, botao) {
    if (!reserva || reserva.hidden) return;
    var pendente = reserva.getAttribute && reserva.getAttribute('data-mak-pix-pendente') === '1';
    reserva.hidden = true;
    if (reserva.removeAttribute) {
      reserva.removeAttribute('data-mak-pix-pendente');
      reserva.removeAttribute('aria-busy');
    }
    if (pendente && botao && typeof botao.click === 'function') setTimeout(function () { botao.click(); }, 0);
  }

  // 24/09: o botão do app (único que aplica o abatimento) vira o principal, verde cheio; o cartão fica secundário.
  function destacarPix(botao) {
    if (!botao || !botao.style || botao.getAttribute('data-mak-pix-destaque')) return;
    botao.setAttribute('data-mak-pix-destaque', '1');
    botao.style.setProperty('background', '#1F6B4A', 'important');
    botao.style.setProperty('border-color', '#1F6B4A', 'important');
    botao.style.setProperty('color', '#ffffff', 'important');
    botao.style.setProperty('font-weight', '700', 'important');
  }

  function sincronizarScala() {
    var candidatos = document.querySelectorAll('[data-mak-checkout-cta]');
    var pronto = false, pendente = false;
    for (var i = 0; i < candidatos.length; i++) {
      var nativo = candidatos[i];
      if (!nativo.closest || nativo.closest('#checkout') !== nativo) continue;
      var container = containerDe(nativo);
      var host = container && container.querySelector ? container.querySelector('scala-cart-button') : null;
      var botao = host && host.shadowRoot ? host.shadowRoot.querySelector('#scala-button') : null;
      var opcoes = container && container.querySelector ? container.querySelector('[data-mak-pay-options]') : null;
      if (nativo.hasAttribute('data-mak-native-fallback')) {
        nativo.hidden = false;
        nativo.removeAttribute('aria-hidden');
        nativo.removeAttribute('data-mak-native-fallback');
      }
      var reserva = container && container.querySelector ? container.querySelector('[data-mak-pix-placeholder]') : null;
      if (!host || !botao) {
        if (host && !botao) pendente = true;
        if (reservaAtiva(reserva)) {
          pendente = true;
          rotularNativo(nativo, true);
          if (opcoes) opcoes.hidden = false;
          continue;
        }
        rotularNativo(nativo, false);
        if (opcoes) opcoes.hidden = true;
        continue;
      }
      if (reserva) liberarReserva(reserva, botao);
      host.setAttribute('data-mak-scala-ready', '1');
      host.setAttribute('data-mak-checkout-cta', '');
      tornarScalaAcessivel(host, botao);
      destacarPix(botao);
      rotularNativo(nativo, true);
      if (opcoes) opcoes.hidden = false;
      pronto = true;
    }
    return !pendente;
  }

  // O botão Scala nasce dentro de um shadow root: essa mutação não é vista pelo observador do DOM claro
  // (ex.: drawer do carrinho na PDP). Repetir a sincronização por tempo limitado até o botão existir.
  var sincronizacaoScalaTimer = null, sincronizacaoScalaLimite = 0;
  function agendarSincronizacaoScala() {
    if (typeof setInterval !== 'function' || typeof clearInterval !== 'function') return;
    sincronizacaoScalaLimite = Date.now() + 15000;
    if (sincronizacaoScalaTimer) return;
    sincronizacaoScalaTimer = setInterval(function () {
      var concluido = sincronizarScala();
      if (concluido || Date.now() > sincronizacaoScalaLimite) {
        clearInterval(sincronizacaoScalaTimer);
        sincronizacaoScalaTimer = null;
      }
    }, 300);
  }

  function controlesCheckout() {
    var controles = [];
    var nativo = document.querySelector('#checkout');
    var host = document.querySelector('scala-cart-button[data-mak-scala-ready]');
    var scala = host && host.shadowRoot ? host.shadowRoot.querySelector('#scala-button') : null;
    if (nativo) controles.push(nativo);
    if (scala) controles.push(scala);
    return controles;
  }

  // Vindo da gaveta (botão Pix): segue para o Pix assim que o app carregar nesta página.
  try {
    if (naPaginaCarrinho() && /(?:^|[?&])mak_pix=1(?:&|$)/.test(location.search || '')) {
      var reservaVinda = document.querySelector('.cart__ctas [data-mak-pix-placeholder]');
      if (reservaVinda) {
        reservaVinda.setAttribute('data-mak-pix-pendente', '1');
        reservaVinda.setAttribute('aria-busy', 'true');
        reservaVinda.textContent = 'Preparando o Pix…';
      }
      if (history && history.replaceState) history.replaceState(null, '', location.pathname);
    }
  } catch (e) {}

  if (!sincronizarScala()) agendarSincronizacaoScala();
  if (typeof customElements !== 'undefined' && customElements.whenDefined) {
    customElements.whenDefined('scala-cart-button').then(function () { if (!sincronizarScala()) agendarSincronizacaoScala(); });
  }
  if (typeof MutationObserver === 'function' && document.documentElement) {
    new MutationObserver(function () { if (!sincronizarScala()) agendarSincronizacaoScala(); }).observe(document.documentElement, { childList: true, subtree: true });
  }

  var checkoutFluxo = 'idle';

  function comPrazoTotal(tarefa) {
    var timer, expirado = false, cancelar = function () {};
    return new Promise(function (resolve, reject) {
      timer = setTimeout(function () {
        expirado = true;
        cancelar();
        var erro = new Error('A confirmação demorou. Recarregue a página antes de tentar novamente.');
        erro.code = 'timeout';
        reject(erro);
      }, 8000);
      Promise.resolve().then(function () {
        return tarefa({
          beforeMutation: function () {
            if (expirado) {
              var erro = new Error('A confirmação demorou. Recarregue a página antes de tentar novamente.');
              erro.code = 'timeout';
              throw erro;
            }
          },
          onCancel: function (fn) { cancelar = fn; if (expirado) fn(); }
        });
      }).then(function (valor) {
        if (expirado) return;
        clearTimeout(timer);
        resolve(valor);
      }, function (erro) {
        if (expirado) return;
        clearTimeout(timer);
        reject(erro);
      });
    });
  }

  function liberarFluxo(botao, erro) {
    var prazoExpirado = erro && erro.code === 'timeout';
    if (prazoExpirado) {
      checkoutFluxo = 'reload_required';
      var ctas = controlesCheckout();
      for (var i = 0; i < ctas.length; i++) {
        ctas[i].disabled = true;
        ctas[i].removeAttribute('aria-busy');
      }
      var status = document.querySelector('[data-mak-checkout-status]');
      if (status) {
        status.textContent = errorMessage(erro);
        status.hidden = false;
      }
    } else {
      botao.disabled = false;
      botao.removeAttribute('aria-busy');
      checkoutFluxo = 'idle';
    }
    window.alert(errorMessage(erro));
  }

  function errorMessage(error) {
    return error && error.message ? error.message : 'Não consegui confirmar os dados para o checkout. Tente novamente.';
  }

  document.addEventListener('click', function (ev) {
    var alvo = ev.target instanceof Element ? ev.target : null;
    if (!alvo) return;

    var reservaClicada = alvo.closest('[data-mak-pix-placeholder]');
    if (reservaClicada) {
      ev.preventDefault();
      ev.stopPropagation();
      if (reservaClicada.getAttribute('data-mak-pix-pendente') === '1') return;
      var docReserva = docOk(reservaClicada);
      if (!docReserva.ok) return;
      if (!naPaginaCarrinho()) {
        reservaClicada.setAttribute('data-mak-pix-pendente', '1');
        reservaClicada.setAttribute('aria-busy', 'true');
        reservaClicada.textContent = 'Preparando o Pix…';
        var envio = gravarDocumento(docReserva.valor);
        envio.promise.then(function () { location.href = '/cart?mak_pix=1'; }, function (erro) {
          reservaClicada.removeAttribute('data-mak-pix-pendente');
          reservaClicada.removeAttribute('aria-busy');
          reservaClicada.textContent = 'Finalizar compra com Pix';
          window.alert(errorMessage(erro));
        });
        return;
      }
      reservaClicada.setAttribute('data-mak-pix-pendente', '1');
      reservaClicada.setAttribute('aria-busy', 'true');
      reservaClicada.textContent = 'Preparando o Pix…';
      if (!sincronizarScala()) agendarSincronizacaoScala();
      return;
    }

    var scala = scalaDoEvento(ev);
    if (scala && scala.host.hasAttribute('data-mak-handoff-pronto')) {
      scala.host.removeAttribute('data-mak-handoff-pronto');
      return;
    }
    if (scala) {
      ev.preventDefault();
      ev.stopPropagation();
      if (typeof ev.stopImmediatePropagation === 'function') ev.stopImmediatePropagation();
      if (scala.botao.disabled || checkoutFluxo !== 'idle') return;
      var docScala = docOk(scala.host); if (!docScala.ok) return;
      checkoutFluxo = 'running';
      scala.botao.disabled = true;
      scala.botao.setAttribute('aria-busy', 'true');
      comPrazoTotal(function (controle) {
        controle.beforeMutation();
        var modo = gravarDocumento(docScala.valor);
        controle.onCancel(modo.cancel);
        return modo.promise;
      }).then(function () {
        scala.host.setAttribute('data-mak-handoff-pronto', '1');
        scala.botao.disabled = false;
        scala.botao.removeAttribute('aria-busy');
        checkoutFluxo = 'idle';
        scala.botao.click();
      }, function (error) {
        liberarFluxo(scala.botao, error);
      });
      return;
    }

    var botaoNormal = alvo.closest('#checkout');
    if (botaoNormal && botaoNormal.hasAttribute('data-mak-handoff-pronto')) {
      botaoNormal.removeAttribute('data-mak-handoff-pronto');
      return;
    }
    if (botaoNormal) {
      ev.preventDefault();
      ev.stopPropagation();
      if (botaoNormal.disabled || checkoutFluxo !== 'idle') return;
      var docNormal = docOk(botaoNormal); if (!docNormal.ok) return;
      checkoutFluxo = 'running';
      botaoNormal.disabled = true;
      botaoNormal.setAttribute('aria-busy', 'true');
      comPrazoTotal(function (controle) {
        controle.beforeMutation();
        var modo = gravarDocumento(docNormal.valor, { _scaladiscount: '0' });
        controle.onCancel(modo.cancel);
        return modo.promise;
      }).then(function () {
        return urlCheckoutComEndereco();
      }).then(function (urlEndereco) {
        if (urlEndereco && typeof location !== 'undefined') {
          location.href = urlEndereco;
          return;
        }
        botaoNormal.setAttribute('data-mak-handoff-pronto', '1');
        botaoNormal.disabled = false;
        botaoNormal.removeAttribute('aria-busy');
        checkoutFluxo = 'idle';
        botaoNormal.click();
      }, function (error) {
        liberarFluxo(botaoNormal, error);
      });
    }
  }, true);
})();
